

import config from "../Context/Config"; // Adjust the path based on your project
import { showSwal } from "./swal";
import { handleApiError } from "./error";

export const autosave = async ( form_type, data) => {
    try {

        const response = await fetch(`${config.API_BASE_URL}/patient_auto_save`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: config.accessToken,
            },
            body: JSON.stringify({
                form: data
            }),
        });

        if (response.ok) {
            const data = await response.json();
            if (data === "code not found") {
                return false;
            }
            return true;
        }

        await handleApiError(response.status, async () => {
            // Retry original call after refresh
            return await autosave(form_type, data);
        });

    } catch (error) {
        showSwal("error", "Network Error", "Unable to connect to server. Please try again later.");
    }
};
